import { motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";
import { PRICE } from "@/config";

export const FinalCTA = () => (
    <section data-testid="final-cta-section" className="relative py-28 sm:py-40 lg:py-48 bg-[#0E0818] border-t border-orchid/20 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(168,85,247,0.22),transparent_60%)] pointer-events-none" />
        <div className="absolute -bottom-24 left-1/4 w-[40vw] h-[40vw] rounded-full bg-gold/15 blur-[110px] pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
            <motion.h2
                data-testid="final-headline"
                initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                className="font-serif uppercase font-semibold tracking-tight text-4xl sm:text-6xl lg:text-7xl leading-[1.05]"
            >
                Start Thinking <span className="gold-text italic">Differently.</span>
            </motion.h2>
            <motion.p
                initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.9, delay: 0.2 }}
                className="mt-8 font-sans font-light tracking-[0.25em] uppercase text-sm sm:text-base text-zinc-300"
            >
                AI + Marketing + Consciousness of Abundance
            </motion.p>
            <motion.p
                initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.9, delay: 0.3 }}
                className="mt-4 font-mono text-[11px] tracking-[0.25em] uppercase text-zinc-500"
            >
                Digital Book — <span className="text-gold">{PRICE}</span> — Plus Tuesday Live Webinar 7 PM Central
            </motion.p>
            <motion.div
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.4 }}
                className="mt-12"
            >
                <button
                    data-testid="final-cta-button"
                    onClick={() => scrollToId("checkout")}
                    className="group relative overflow-hidden bg-gold text-black font-mono text-xs sm:text-sm tracking-[0.2em] uppercase px-12 py-5 hover:bg-gold-light transition-colors duration-300"
                >
                    <span className="relative z-10">Get Instant Access — {PRICE}</span>
                    <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/40 to-transparent" />
                </button>
            </motion.div>
        </div>
        <footer className="relative mt-24 border-t border-white/5 pt-8 pb-4">
            <p className="text-center font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-600">
                © {new Date().getFullYear()} Toriano Sanzone — AI + Marketing
            </p>
        </footer>
    </section>
);
